/* eslint-disable max-len */

const UndoSvg = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    pointerEvents="none"
  >
    <path
      d="M5.36035 4C5.36035 4 8.3692 4.00001 10.3604 4.00001C14.0422 4.00001 17.027 6.79823 17.027 10.25C17.027 13.7018 14.0422 16.5 10.3604 16.5H5.36035"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.36035 2L5.00333 4.35702L7.36035 6.71404"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>

);

export default UndoSvg;
